<template>
  <div class="btn-toggle">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'btn-toggle'
}
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";
.btn-toggle {
  cursor: pointer;
  &.-plus {
    background-image: url('../../assets/images/icons/minus.svg');
    background-position: right 0px center;
    background-repeat: no-repeat;
    background-size: 14px auto;
    @include mq-up(){
      background-size: 20px 20px;
    }
  }
  &.-plus.collapsed {
    background-image: url('../../assets/images/icons/plus.svg');
  }
}
.card-header {
  .btn-toggle {
    .heading {
      font-size: 16px;
      font-weight: bold;
      max-width: 92%;
      width: 100%;
      @include mq-up(md) {
        max-width: 95%;
        font-size: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/button/BtnToggle.vue